(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fes-editorial-landing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(e){var step=e.target.closest('[data-qty]');if(step){var input=step.parentElement.querySelector('input');var n=Math.max(1,parseInt(input.value,10)||1);input.value=step.dataset.qty==='plus'?n+1:Math.max(1,n-1);return}var thumb=e.target.closest('.fes-story__thumb');if(!thumb)return;var root=thumb.closest('.fes-story');var image=root.querySelector('.fes-story__image');image.src=thumb.dataset.photo;image.alt=thumb.dataset.alt||image.alt;image.removeAttribute('srcset');root.querySelectorAll('.fes-story__thumb').forEach(function(t){t.classList.toggle('active',t===thumb);t.setAttribute('aria-pressed',t===thumb?'true':'false')})});document.addEventListener('change',function(e){if(!e.target.matches('.fes-story__select'))return;var root=e.target.closest('.fes-story'),o=e.target.selectedOptions[0],button=root.querySelector('.fes-story__add');root.querySelector('[data-fes-price]').textContent=o.dataset.price;button.disabled=o.dataset.available!=='true';root.querySelector('[data-fes-label]').textContent=button.disabled?'Sold out':'Add to cart';if(o.dataset.photo){var image=root.querySelector('.fes-story__image');image.src=o.dataset.photo;image.removeAttribute('srcset')}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  
  

  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  let couponCodeField = document.getElementById('coupon_code_cart'),
	  couponCodeGet = localStorage.getItem("coupon");
  if (couponCodeField && couponCodeGet) couponCodeField.value = couponCodeGet;




  } catch(e) { console.error(e); }
})();
})();
